<template>
  <v-card
    outlined
    :class="{
      'strategio-hidden-item': process.isEnabled === 0
    }"
    :style="[
      {'height': '282px'},
      {'width': '313px'},
      {'margin': '20px'},
      {'overflow': 'hidden'},
      {'background': '#FFFFFF'},
      {'border': '1px solid rgba(0, 0, 0, 0.05)'},
      {'border-radius': '10px'}
    ]"
    @click="showProcess"
    class="d-flex flex-column justify-center align-center"
  >
    
    <div>
      <v-icon :color="'black'" style="font-size:52px;"
        >ico-icon-config</v-icon>
    </div>
    
    <div
      class="strategio-autoservicio-card-title"
      style="margin-top: 15px;"
    >
      {{process.processName}}
    </div>
  </v-card>
</template>

<script>
import userStorage from '../../../storage/userStorage'

export default {
  name: 'autoservicio-process',
  data () {
    const user = userStorage.getUserInfo()
    return {
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN'
    }
  },
  components: {
  },
  props: {
    process: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    showProcess () {
      let processType = this.process.processType.toLowerCase()
      let processID = this.process.processID
      this.$router.push(`/autoservicios/process/${processID}/${processType}/`)
    }
  },
  computed: {
  },
  mounted () {
  }
}
</script>
<style scoped>
.strategio-hidden-item {
  opacity: 0.5;
}

.strategio-autoservicio-card-title {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 24px;
  color: #25235F;
  -webkit-text-stroke: 0.3px #25235F;
}

.strategio-autoservicio-card-subtitle {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.5);
}



</style>



// WEBPACK FOOTER //
// src/components/autoservicios/processes/autoservicio-process.vue